<template>
  <table
    v-if="data.length > 0"
    class="my-release-list__table">
    <thead class="my-release-list__thead">
      <tr>
        <th
          v-for="header in headers"
          :key="header.id"
          :style="header.style"
          :class="header.class">
          {{ header.name }}
          <i
            v-if="header.isIcon"
            v-tooltip="'個人情報保護の観点からあなた以外のメンバーは表示されていません。'"
            class="tooltip-icon"
            style="display: inline;top:2px;">
          </i>
        </th>
      </tr>
    </thead>
    <tbody class="my-release-list__tbody">
      <tr
        v-for="(item) in data"
        :key="item.id"
        :class="data.length === 1 ? 'b0' : ''">
        <td
          v-for="key in headers"
          :key="key.id">
          <template v-if="key.button">
            <template v-for="(buttonText, index) in key.buttonText">
              <button
                v-if="shouldDisplayButton(item, pageName, index)"
                :key="index"
                :class="key.buttonClass"
                :style="key.buttonStyle"
                @click="handleButtonClick(item, pageName, index)">
                {{ buttonText }}
              </button>
            </template>
          </template>
          <template v-else-if="key.key.includes('coverart_filepath')">
            <img
              :src="setSource(item)"
              :style="key.imgStyle" />
          </template>
          <template v-else>
            <span
              v-if="item[key.key] === 1 || item[key.key] === 2"
              class="pending">
              {{ setTableData(key, item) }}
            </span>
            <span v-else>
              {{ setTableData(key, item) }}
            </span>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
  <div
    v-else
    class="artist-list">
    <p class="artist-not-exist">
      {{ emptyText }}
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import { REVENUE_SHARE_COMPLETE_STATUS, REVENUE_SHARE_STATUS } from '../../../consts/status'

export default {
  name: 'RevenueShareDetailTable',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    pageName: {
      type: String,
      required: true,
    },
    isAccountComplete: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      status: REVENUE_SHARE_STATUS,
      completeStatus: REVENUE_SHARE_COMPLETE_STATUS,
      revenueShareIndex: 'revenueShareIndex',
      revenueShare: 'revenueShare',
      collaboratorDetailForAlbum: 'collaboratorDetailForAlbum',
      detailForAlbum: 'detailForAlbum',
      detail: 'detail',
      collaboratorDetail: 'collaboratorDetail',
      typeAlbum: 'album',
      step2Album: '/client/revenue-share/album/step-2/',
      step2Url: '/client/revenue-share/step-2/',
      route: '/client/revenue-share/confirm-revenue-share/',
      invitationLink: '/client/revenue-share/invitation-code?invitation_code=',
      collaboratorUrl: '/client/revenue-share-collaborator/detail/',
      detailPageUrl: '/client/revenue-share/detail/',
      daysToAdd: 14,
      statusOne: 1,
      statusTwo: 2,
      statusThree: 3,
    }
  },
  methods: {
    setTableData(key, item) {
      if (key.actionable) {
        switch (key.key) {
          case 'title':
            return item.type === this.typeAlbum ? item.productTitle : item.title
          case 'type':
            return item.type === this.typeAlbum ? 'アルバム' : 'シングル'
          case 'product.type':
            return item.product.type === this.typeAlbum ? 'アルバム' : 'シングル'
          case 'status':
            return this.returnStatus(item.status)
          case 'isComplete':
            return this.returnCompleteStatus(item)
          default:
            return item[key.key]
        }
      }
      if (key.key.includes('.')) {
        const nestedKeys = key.key.split('.')
        return nestedKeys.reduce((obj, nestedKey) => obj[nestedKey], item)
      }
      if (key.pipe && key.pipe === 'addDaysToDate') {
        if (item.owner) {
          return '-'
        }
        return this.setDate(item.updated_at)
      }
      if (key.pipe && key.pipe === 'formatDate') {
        if (item.owner) {
          return '-'
        }
        return moment(item.updated_at).format('YYYY-MM-DD HH:mm')
      }
      if (key.key === 'rate') {
        return `${item[key.key]}%`
      }
      if (key.key === 'email' && item.owner) {
        return `${item[key.key]} (管理者)`
      }
      return item[key.key]
    },
    handleButtonClick(item, pageName, index) {
      const session = JSON.parse(window.sessionStorage.getItem('split')) || {}
      const redirectToPage = (url) => this.$emit('redirectToPage', url)
      switch (pageName) {
        case this.detail:
        case this.detailForAlbum:
          this.$emit('handleClick', item)
          break

        case this.collaboratorDetailForAlbum:
        case this.collaboratorDetail:
          session.revenueShareId = item.id
          if (!this.isAccountComplete) {
            session.invitationCode = item.code
            // user's required account information is not registered return blank url.
            redirectToPage('')
          } else if (item.status === this.statusOne) {
            redirectToPage(this.invitationLink + item.code)
          } else {
            redirectToPage(`${this.route}${item.product_disc_tracks.product.id}/${item.id}`)
          }
          break

        case this.revenueShare:
          session.productId = item.product_id
          redirectToPage(item.type === this.typeAlbum ? `${this.step2Album}${item.product_id}` : `${this.step2Url}${item.product_id}`)
          break

        case this.revenueShareIndex:
          session.productId = item.product_id
          if (index === 0) {
            if (item.owner && item.product_disc_tracks.product.type === 'single') {
              redirectToPage(`${this.detailPageUrl}${item.product_id}`)
            } else if (item.owner && item.product_disc_tracks.product.type === this.typeAlbum) {
              if (item.isCompleteSplit) {
                redirectToPage(`${this.detailPageUrl}album/${item.product_id}`)
              } else {
                redirectToPage(`${this.step2Album}${item.product_id}`)
              }
            } else if (item.product_disc_tracks.product.type === this.typeAlbum) {
              redirectToPage(`${this.collaboratorUrl}album/${item.product_id}`)
            } else {
              redirectToPage(`${this.collaboratorUrl}${item.product_id}`)
            }
          } else if (index === 1 && item.owner && !item.isComplete) {
            this.$emit('cancelRevenueShare', item.product_disc_track_id)
          }
          break
        default:
          break
      }
      window.sessionStorage.setItem('split', JSON.stringify(session))
    },
    returnStatus(status) {
      return this.status[status]
    },
    returnCompleteStatus(item) {
      if (item.isComplete && item.isCompleteSplit && item.owner) return this.completeStatus[1]
      if (item.isComplete && !item.owner) return this.completeStatus[1]
      return this.completeStatus[0]
    },

    shouldDisplayButton(item, pageName, index) {
      if (pageName === this.detail || pageName === this.detailForAlbum) {
        return item.status === this.statusOne || item.status === this.statusTwo
      } if (pageName === this.collaboratorDetailForAlbum || pageName === this.collaboratorDetail) {
        if (index === 1) {
          return !this.isAccountComplete
        } return this.isAccountComplete && item.status !== this.statusThree
      }
      if (pageName === this.revenueShare) {
        return true
      }
      if (pageName === this.revenueShareIndex) {
        if (index === 0) return true
        if (index === 1 && item.owner && !item.isComplete) return true
      }
      return false
    },
    setSource(item) {
      if (this.pageName === this.revenueShareIndex) {
        return `/images/${item.product_disc_tracks.product.coverart_filepath}`
      }
      return `/images/${item.coverart_filepath}`
    },
    setDate(date) {
      if (date) {
        return moment(new Date(date)).add(this.daysToAdd, 'days').format('YYYY-MM-DD HH:mm')
      }
      return date
    },
  },
}
</script>

<style scoped>

.my-release-list__thead {
  border-bottom: 2px solid #e8e8e8;
}

.my-release-list__thead th {
  background-color: #d5d3e1;
  text-align: center;
}

@media screen and (min-width: 896px) {
  .my-release-list__thead th {
    border: none;
    font-size: 1.4rem;
    padding: 15px;
  }
}

@media screen and (max-width: 895px) {
  .my-release-list__thead th {
    border: none;
    padding: 2.66667vw;
    white-space: nowrap;
  }
}

.my-release-list__tbody td {
  background-color: #fff;
  text-align: center;
  vertical-align: middle;
}

@media screen and (min-width: 896px) {
  .my-release-list__tbody td {
    border: none;
    font-size: 1.4rem;
    padding: 15px;
    word-break: break-word;
  }
}

@media screen and (max-width: 895px) {
  .my-release-list__tbody td {
    border: none;
    padding: 2.66667vw;
    word-break: break-word;
  }
}

.my-release-list__tbody tr {
  border-bottom: 2px solid #e8e8e8;
}

.b0 {
  border: none !important;
}
.pending {
  color: #cc0000;
}
</style>
